<script>
  import { fade } from "svelte/transition";
  import ArticlePagination from "./components/ArticlePagination.svelte";
  import { webfetch } from "../svelte_utils";
  import AdviceCards from "./components/AdviceCards.svelte";
  import { category_tags, page_count } from "./stores/stores";
  import { onMount, tick } from "svelte";
  import FilterIcon from "./components/FilterIcon.svelte";
  import TagList from "./components/TagList.svelte";
  /**
   * @typedef {Object} Props
   * @property {string} [article_api_endpoint]
   * @property {any} existing_container
   */

  /** @type {Props} */
  let { article_api_endpoint = "", existing_container } = $props();

  let advice_content = $state({ results: [], filters: {} });
  let active_cards = $state(void 0);
  let seasons = "summer;autumn;winter;spring";
  let error = void 0;
  let loading = false;
  let category = $state(false);
  let tag = $state(false);
  let season = $state(false);
  let investment = $state(false);
  let type = $state(false);
  let safe = $state(false);
  let show_default_content = $state(true);
  let active = $derived(safe && (type || investment || season || tag || category));

  const handleClear = () => {
    if (safe) {
      page_count.reset();
      category_tags.reset();
      tick();
      active_cards = advice_content.results;
      show_default_content = true;
    }
  };

  const handleFilter = (result) =>
    result.tags.split(";").some((s) => $category_tags[s.toLowerCase()]);

  const handleApply = () => {
    if (safe) {
      category = false;
      tag = false;
      season = false;
      investment = false;
      type = false;
      show_default_content = false;

      for (const [key, value] of Object.entries($category_tags)) {
        if (value == false) {
          delete $category_tags[key];
        }
      }

      if (Object.keys($category_tags).length === 0) {
        handleClear();
      } else {
        active_cards = advice_content.results.filter(handleFilter);
      }

      // update Gtm
      let f = Object.keys($category_tags).flatMap((key) =>
        $category_tags[key] ? [key] : [],
      );
      if (window && window.digitalData) {
        window.digitalData.tool = {
          name: "waterwise advice filter",
          step: "complete",
          result: `{${f.length};tags=${f.join(",")}}`,
        };
        if (window.dataLayer) {
          dataLayer.push({ event: "toolComplete" });
        }
      }
    }
  };

  function calculateArticlesToDisplay() {
    if ($page_count * 6 > active_cards.length) {
      return active_cards.length;
    }
    let articleno = $page_count * 6;
    articleno = articleno == 0 ? $page_count + 6 : articleno;
    return articleno;
  }

  async function fetchArticles() {
    loading = true;
    try {
      advice_content = await webfetch(article_api_endpoint);
      loading = false;
      tick();
      if (
        !error &&
        advice_content &&
        advice_content.filters &&
        advice_content.results
      ) {
        let params = new URLSearchParams(window.location.search);
        let hasTag = params.has("tag");
        if (hasTag) {
          active_cards = advice_content.results;
          params.getAll("tag").forEach((t) => {
            let low = t.toLowerCase();
            category_tags.add(low);
            active_cards = active_cards.filter(
              (result) =>
                result.category.toLowerCase() == low ||
                result.tags.split(";").some((s) => s.toLowerCase() === low),
            );
          });
          show_default_content = false;
        } else {
          active_cards = advice_content.results;
        }
        safe = true;
      }
    } catch (err) {
      error = err;
      loading = false;
    }
  }

  onMount(() => {
    fetchArticles();
    tick();
  });
</script>

<section class="w-full">
  <h5>Filter by</h5>
  <nav class="wc-wa-filter__nav">
    <ul class="wc-wa-filter__nav-list">
      <li class="wc-wa-filter__nav-item" class:category>
        <button
          class="wc-wa-filter__nav-btn"
          onclick={() => {
            tag = false;
            season = false;
            investment = false;
            type = false;
            category = !category;
          }}
        >
          Category
          <FilterIcon rotate={category} />
        </button>
      </li>
      <!-- <li class="wc-wa-filter__nav-item" class:tag>
        <button
          class="wc-wa-filter__nav-btn"
          onclick={() => {
            category = false;
            season = false;
            investment = false;
            type = false;
            tag = !tag;
          }}>
          Tag
          <FilterIcon rotate={tag} />
        </button>
      </li> -->
      <li class="wc-wa-filter__nav-item" class:season>
        <button
          class="wc-wa-filter__nav-btn"
          onclick={() => {
            category = false;
            tag = false;
            investment = false;
            type = false;
            season = !season;
          }}
        >
          Season
          <FilterIcon rotate={season} />
        </button>
      </li>

      <!-- <li class="wc-wa-filter__nav-item" class:type>
        <button
          class="wc-wa-filter__nav-btn"
          onclick={() => {
            category = false;
            tag = false;
            season = false;
            investment = false;
            type = !type;
          }}>
          Type
          <FilterIcon rotate={type} />
        </button>
      </li> -->
      <li class="wc-wa-filter__nav-item" class:investment>
        <button
          class="wc-wa-filter__nav-btn"
          onclick={() => {
            category = false;
            tag = false;
            season = false;
            type = false;
            investment = !investment;
          }}
        >
          Cost
          <FilterIcon rotate={investment} />
        </button>
      </li>
      {#if !active}
        <li class="wc-wa-filter__nav-item wc-wa-filter__nav-item--filter">
          <button
            class="wc-wa-filter__nav-btn wc-wa-filter__nav-btn--link"
            style="width: 100%;"
            onclick={handleClear}
            in:fade|global={{ duration: 500, delay: 500 }}
          >
            CLEAR ALL FILTERS
          </button>
        </li>
      {/if}
    </ul>
    {#if active}
      <hr class="m-0" out:fade|global={{ duration: 500, delay: 500 }} />
    {/if}
    <div class="wc-wa-filter__panel" class:active>
      {#if active}
        <TagList
          tags={(category && advice_content.filters.categories) ||
            (season && seasons) ||
            (investment && advice_content.filters.investments)}
        />
        <div class="wc-wa-filter__actions">
          <button
            class="btn-primary btn-mobile"
            onclick={handleApply}
            transition:fade
          >
            APPLY
          </button>
          <button
            in:fade|global={{ duration: 50, delay: 50 }}
            class="wc-wa-filter__nav-btn wc-wa-filter__nav-btn--link mb"
            onclick={handleClear}
          >
            CLEAR ALL FILTERS
          </button>
        </div>
      {/if}
    </div>
  </nav>
  <!-- existing content -->
  {#if show_default_content && existing_container}
    <div>
      {@html existing_container.outerHTML}
    </div>
  {/if}

  {#if active_cards}
    <AdviceCards
      cards={active_cards.slice(
        ($page_count - 1) * 6,
        calculateArticlesToDisplay(),
      )}
    />
  {/if}

  {#if active_cards && active_cards.length > 6}
    <ArticlePagination
      resultsPerPage="6"
      totalPages={Math.ceil(active_cards.length / 6)}
    />
  {/if}
</section>

<style>
  .mb {
     margin-bottom: 1.2rem;
  }
   .active {
     height: auto;
     margin-top: 0;
  }
   @media (min-width: 768px) {
     .active {
       height: 280px;
    }
  }
   @media (min-width: 1039px) {
     .active {
       height: 200px;
    }
  }
   .category, .season, .investment {
     outline: 1px solid #c7c7c7;
     box-sizing: border-box;
     border: none;
  }
   .category > button, .season > button, .investment > button {
     color: #333;
     text-decoration: none;
  }
   @media (min-width: 1039px) {
     .category, .season, .investment {
       background: white;
       outline: none;
       box-sizing: border-box;
       border: 1px solid #c7c7c7;
       border-top: none;
       border-bottom: none;
       margin-bottom: -1px;
       z-index: 1;
    }
  }
   
  </style>
  
